"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.provide = void 0;
var polyfill_1 = require("../polyfill");
exports.provide = function () { return typeof window !== 'undefined' && typeof window.Wix !== 'undefined'
    ? window.Wix
    : polyfill_1.polyfill; };
//# sourceMappingURL=provider.js.map